import request from "utils/request";

//法律条例分类
function gettiaoliify(data) {
  return request({
    url: "/api/statutecats",
    params: data
  });
}

//法律条例列表
function gettiaolilist(data) {
  return request({
    url: "/api/statutelist",
    params: data
  });
}

//法律条例详情
function gettiaolicontent(data) {
  return request({
    url: "/api/statutecontent",
    params: data
  });
}



//罪名库分类
function getzuiminify(data) {
  return request({
    url: "/api/crimecats",
    params: data
  });
}

//罪名库列表
function getzuiminlist(data) {
  return request({
    url: "/api/crimelist",
    params: data
  });
}
//罪名库内容
function getzuimincontent(data) {
  return request({
    url: "/api/crimecontent",
    params: data
  });
}

//解决方案分类
function getsolutionify(data) {
  return request({
    url: "/api/solutioncats",
    params: data
  });
}

//解决方案列表
function getsolutionlist(data) {
  return request({
    url: "/api/solutionlist",
    params: data
  });
}

//解决方案内容页
function getsolutioncontent(data) {
  return request({
    url: "/api/solutioncontent",
    params: data
  });
}

//合同范本分类
function getcontractify(data) {
  return request({
    url: "/api/contractcats",
    params: data
  });
}
//合同范本列表
function getcontractlist(data) {
  return request({
    url: "/api/contractlist",
    params: data
  });
}
//合同范本详情
function getcontractcontent(data) {
  return request({
    url: "/api/contractcontent",
    params: data
  });
}


export default {
  gettiaoliify,
  getzuiminify,
  getsolutionify,
  getcontractify,
  
  gettiaolilist,
  getzuiminlist,
  getsolutionlist,
  getcontractlist,

  getzuimincontent,
  getsolutioncontent,
  getcontractcontent,
  gettiaolicontent,

};